import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type AppTheme = 'dark' | 'light';

const THEME_STORAGE_KEY = 'studio-theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly themeSubject = new BehaviorSubject<AppTheme>('dark');
  readonly theme$ = this.themeSubject.asObservable();

  initTheme(): void {
    const storedTheme = localStorage.getItem(THEME_STORAGE_KEY);
    const theme: AppTheme = storedTheme === 'light' ? 'light' : 'dark';
    this.applyTheme(theme);
  }

  setTheme(theme: AppTheme): void {
    this.applyTheme(theme);
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  }

  toggleTheme(): void {
    this.setTheme(this.themeSubject.value === 'dark' ? 'light' : 'dark');
  }

  getTheme(): AppTheme {
    return this.themeSubject.value;
  }

  isDarkTheme(): boolean {
    return this.themeSubject.value === 'dark';
  }

  private applyTheme(theme: AppTheme): void {
    this.themeSubject.next(theme);

    document.body.classList.remove('theme-dark', 'theme-light');
    document.body.classList.add(theme === 'dark' ? 'theme-dark' : 'theme-light');
  }
}
